type NavigateFn = (path: string) => void;

let navigateFn: NavigateFn | null = null;

export function registerAppNavigate(fn: NavigateFn | null): void {
  navigateFn = fn;
}

/** 前景橫幅等非 React 模組導頁（有 Router 時不整頁重整） */
export function appNavigate(path: string): void {
  if (navigateFn) {
    navigateFn(path);
    return;
  }
  window.location.href = path;
}
